import { Region } from '@monthio/react-components'

const regionsWithCrown = [Region.Denmark, Region.Norway, Region.Sweden]
const regionsWithEuro = [Region.Spain, Region.Finland, Region.Netherlands]

export const customBanks = [
	{
		id: '35',
		header: 'Person with strong economy',
		highlights: ['Owns a car', 'Has a child', 'High disposable amount', 'Freelances on the side'],
		regions: regionsWithCrown.concat(regionsWithEuro),
	},
	{
		id: '36',
		header: 'Person who got a raise',
		highlights: ['Moved to more expensive home', 'Has consumer loans', 'Has debt collection', 'High pleasure expenses'],
		regions: regionsWithCrown.concat(regionsWithEuro),
	},
	{
		id: '37',
		header: 'Person who lost their job',
		highlights: ['Negative disposable amount', 'Has consumer loans', 'Has debt collection', 'High gambling expenses'],
		regions: regionsWithCrown.concat(regionsWithEuro),
	},
	{ id: '1', header: 'Profile 1', highlights: ['NDI 1000'], regions: regionsWithCrown },
	{ id: '2', header: 'Profile 2', highlights: ['NDI 2000'], regions: regionsWithCrown },
	{ id: '3', header: 'Profile 3', highlights: ['NDI 3000, no rent, 6mo data'], regions: regionsWithCrown },
	{ id: '4', header: 'Profile 4', highlights: ['NDI 4000, no rent'], regions: regionsWithCrown },
	{ id: '5', header: 'Profile 5', highlights: ['NDI 4000 w/ debt coll.'], regions: regionsWithCrown },
	{ id: '6', header: 'Profile 6', highlights: ['NDI 5500'], regions: regionsWithCrown },
	{ id: '7', header: 'Profile 7', highlights: ['NDI 6000, no rent, child'], regions: regionsWithCrown },
	{ id: '8', header: 'Profile 8', highlights: ['NDI 7500'], regions: regionsWithCrown },
	{ id: '9', header: 'Profile 9', highlights: ['NDI 8500'], regions: regionsWithCrown },
	{ id: '10', header: 'Profile 10', highlights: ['NDI 13000 w/ gambling', 'Debt coll. and child'], regions: regionsWithCrown },
	{ id: '11', header: 'Profile 11', highlights: ['NDI 13000'], regions: regionsWithCrown },
	{ id: '12', header: 'Profile 12', highlights: ['NDI 0'], regions: regionsWithCrown },
	{ id: '13', header: 'Profile 13', highlights: ['NDI -1000'], regions: regionsWithCrown },
	{ id: '14', header: 'Profile 14', highlights: ['NDI -2500'], regions: regionsWithCrown },
	{ id: '15', header: 'Profile 15', highlights: ['NDI -4000 w/ debt coll.'], regions: regionsWithCrown },
	{ id: '17', header: 'Profile 17', highlights: ['NDI -10000 w/ gambling'], regions: regionsWithCrown },
	{ id: '18', header: 'Profile 18', highlights: ['NDI 8500, no rent'], regions: regionsWithCrown },
	{ id: '19', header: 'Profile 19', highlights: ['No transactions'], regions: regionsWithCrown },
	{ id: '20', header: 'Profile 20', highlights: ['Public debt and inkasso', 'Mortgage w/ salary'], regions: regionsWithCrown },
	{ id: '21', header: 'Profile 21', highlights: ['Each category has +1'], regions: regionsWithCrown },
	{ id: '22', header: 'Profile 22', highlights: ['Each category has -1'], regions: regionsWithCrown },
	{ id: '23', header: 'Profile 23', highlights: ['Good budget, no flags'], regions: regionsWithCrown },
	{ id: '25', header: 'Profile 25', highlights: ['Bad budget, yellow flags'], regions: regionsWithCrown },
	{ id: '26', header: 'Profile 26', highlights: ['Good budget w/ scaling'], regions: regionsWithCrown },
	{ id: '27', header: 'Profile 27', highlights: ['Good budget, insuff. data'], regions: regionsWithCrown },
	{ id: '30', header: 'Profile 30', highlights: ['Good budget, slow bank'], regions: regionsWithCrown },
	{ id: '31', header: 'Profile 31', highlights: ['High income variance'], regions: regionsWithCrown },
	{ id: '32', header: 'Profile 32', highlights: ['Med. income variance'], regions: regionsWithCrown },
	{ id: '33', header: 'Profile 33', highlights: ['Low income variance'], regions: regionsWithCrown },
	{ id: '34', header: 'Profile 34', highlights: ['Multiple income streams'], regions: regionsWithCrown },
]
